var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "rb-modal",
    {
      attrs: {
        options: {
          labels: { buttons: { apply: "Create new note", cancel: "Cancel" } },
        },
      },
      on: {
        hide: function ($event) {
          return _vm.createOrEditNote()
        },
        cancel: function ($event) {
          return _vm.hide()
        },
      },
    },
    [
      _c("div", { attrs: { slot: "header" }, slot: "header" }, [
        _c("div", { class: _vm.$style.Header }, [_vm._v(" Manage Notes ")]),
        _c("p", { class: _vm.$style.Text }, [
          _vm._v(" Manage notes for selected hotels "),
        ]),
      ]),
      _c(
        "div",
        { class: _vm.$style.Body, attrs: { slot: "body" }, slot: "body" },
        [
          _vm.sharedNotes.length || _vm.otherNotes.length
            ? [
                _vm.sharedNotes.length
                  ? _c("div", [
                      _c(
                        "div",
                        {
                          class: _vm.$style.GroupTitle,
                          on: {
                            click: function ($event) {
                              return _vm.toggleGroup("shared")
                            },
                          },
                        },
                        [
                          _vm._v(" Shared Notes "),
                          _c("i", { staticClass: "material-icons" }, [
                            _vm._v(
                              _vm._s(
                                _vm.openCarouselGroup.indexOf("shared") > -1
                                  ? "arrow_drop_up"
                                  : "arrow_drop_down"
                              )
                            ),
                          ]),
                        ]
                      ),
                      _c(
                        "div",
                        {
                          class: {
                            [_vm.$style.GroupBody]: true,
                            [_vm.$style.open]:
                              _vm.openCarouselGroup.indexOf("shared") > -1,
                          },
                        },
                        _vm._l(_vm.sharedNotes, function (note) {
                          return _c("div", { key: note.id }, [
                            _c("div", { class: _vm.$style.Note }, [
                              _c("div", {
                                class: _vm.$style.color,
                                style: { backgroundColor: note.color },
                              }),
                              _c("div", { class: _vm.$style.Text }, [
                                _vm._v(_vm._s(note.note)),
                              ]),
                              _c(
                                "div",
                                {
                                  class: ["button main", _vm.$style.EditButton],
                                  on: {
                                    click: function ($event) {
                                      return _vm.createOrEditNote(note)
                                    },
                                  },
                                },
                                [
                                  _c("i", { staticClass: "material-icons" }, [
                                    _vm._v("edit"),
                                  ]),
                                ]
                              ),
                              _c(
                                "div",
                                {
                                  staticClass: "button dark",
                                  on: {
                                    click: function ($event) {
                                      return _vm.deleteNote(note)
                                    },
                                  },
                                },
                                [
                                  _c("i", { staticClass: "material-icons" }, [
                                    _vm._v("delete"),
                                  ]),
                                ]
                              ),
                            ]),
                          ])
                        }),
                        0
                      ),
                    ])
                  : _vm._e(),
                _vm.otherNotes.length
                  ? _c("div", [
                      _c(
                        "div",
                        {
                          class: _vm.$style.GroupTitle,
                          on: {
                            click: function ($event) {
                              return _vm.toggleGroup("others")
                            },
                          },
                        },
                        [
                          _vm._v(" Other Notes "),
                          _c("i", { staticClass: "material-icons" }, [
                            _vm._v(
                              _vm._s(
                                _vm.openCarouselGroup.indexOf("others") > -1
                                  ? "arrow_drop_up"
                                  : "arrow_drop_down"
                              )
                            ),
                          ]),
                        ]
                      ),
                      _c(
                        "div",
                        {
                          class: {
                            [_vm.$style.GroupBody]: true,
                            [_vm.$style.open]:
                              _vm.openCarouselGroup.indexOf("others") > -1,
                          },
                        },
                        _vm._l(_vm.otherNotes, function (note) {
                          return _c("div", { key: note.id }, [
                            _c("div", { class: _vm.$style.Note }, [
                              _c("div", {
                                class: _vm.$style.color,
                                style: { backgroundColor: note.color },
                              }),
                              _c("div", { class: _vm.$style.Text }, [
                                _vm._v(_vm._s(note.note)),
                              ]),
                              _c(
                                "div",
                                {
                                  class: ["button main", _vm.$style.EditButton],
                                  on: {
                                    click: function ($event) {
                                      return _vm.createOrEditNote(note)
                                    },
                                  },
                                },
                                [
                                  _c("i", { staticClass: "material-icons" }, [
                                    _vm._v("edit"),
                                  ]),
                                ]
                              ),
                              _c(
                                "div",
                                {
                                  staticClass: "button dark",
                                  on: {
                                    click: function ($event) {
                                      return _vm.deleteNote(note)
                                    },
                                  },
                                },
                                [
                                  _c("i", { staticClass: "material-icons" }, [
                                    _vm._v("delete"),
                                  ]),
                                ]
                              ),
                            ]),
                          ])
                        }),
                        0
                      ),
                    ])
                  : _vm._e(),
              ]
            : _c("div", { class: _vm.$style.Empty }, [
                _c("div", [_vm._v("Nothing to see here yet")]),
                _c("div", { class: _vm.$style.Text }, [
                  _vm._v(
                    " No notes have been added yet. Click the button below to add a note. "
                  ),
                ]),
                _c(
                  "button",
                  {
                    staticClass: "aBtn asLarge atLight asMain",
                    on: {
                      click: function ($event) {
                        return _vm.createOrEditNote()
                      },
                    },
                  },
                  [
                    _c("i", { staticClass: "material-icons" }, [_vm._v("add")]),
                    _vm._v(" Add Note "),
                  ]
                ),
              ]),
        ],
        2
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }